import { useNavigate } from 'react-router-dom';

const useAuthRedirect = () => {
    const navigate = useNavigate();

    /**
     * Redirects the user to the appropriate dashboard based on their role.
     * @param {string} userRole - The role of the authenticated user ('cpa' or 'customer').
     */
    const redirectToUserDashboard = (userRole) => {
        navigate('/dashboard'); // Fallback or a generic dashboard
    };

    return redirectToUserDashboard;
};

export default useAuthRedirect;